import { eventBus } from 'shared/event-bus';

export const eventEmitterMixin = {
  methods: {
    baseDeferredEmit(name, value) {
      eventBus.deferredEmit(name, value, { element: this.$el });
    },
    emitConsentChanged(value) {
      value = typeof value === 'object' ? value : this.category || this.vendor;
      if (!value) {
        throw new Error('consent-changed event was not emitted because there is no consent to send');
      }
      this.baseDeferredEmit('consent-changed', JSON.parse(JSON.stringify(value)));
    },

    emitPrivacyCenterReInit() {
      this.baseDeferredEmit('privacy-center-reinit');
    },
    emitPrivacyCenterBootloadedEnded() {
      this.baseDeferredEmit('privacy-center-bootload-ended');
    },
    emitPrivacyCenterViewChanged(view) {
      this.baseDeferredEmit('privacy-center-view-changed', view);
    },
  },
};
